// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.horizontal-splitter__left,
.horizontal-splitter__right {
  display: flex;
  overflow: hidden;
}
.horizontal-splitter__left {
  flex: none;
  min-width: 0;
}
.horizontal-splitter__right {
  flex: 1;
}
.horizontal-splitter__slider {
  position: relative;
  background-color: var(--color-border-subdued);
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
  z-index: 1;
}
.horizontal-splitter__slider-handle {
  content: '';
  position: absolute;
  top: 0;
  height: 100%;
}
.horizontal-splitter__slider-ghost {
  background-color: var(--color-border-subdued);
  display: none;
  position: absolute;
  top: 0;
  height: 100%;
  z-index: 100;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/horizontal-splitter/HorizontalSplitter.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AALE;;EACE,aAAA;EACA,gBAAA;AAQJ;AALE;EACE,UAAA;EACA,YAAA;AAOJ;AAJE;EACE,OAAA;AAMJ;AAHE;EACE,kBAAA;EACA,6CAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;AAKJ;AAHE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;AAKJ;AAFE;EACE,6CAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAIJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.horizontal-splitter {\n\n  &__left, &__right {\n    display: flex;\n    overflow: hidden;\n  }\n\n  &__left {\n    flex: none;\n    min-width: 0;\n  }\n\n  &__right {\n    flex: 1;\n  }\n\n  &__slider {\n    position: relative;\n    background-color: var(--color-border-subdued);\n    cursor: col-resize;\n    user-select: none;\n    z-index: 1;\n  }\n  &__slider-handle {\n    content: '';\n    position: absolute;\n    top: 0;\n    height: 100%;\n  }\n\n  &__slider-ghost {\n    background-color: var(--color-border-subdued);\n    display: none;\n    position: absolute;\n    top: 0;\n    height: 100%;\n    z-index: 100;\n    opacity: 0.8;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
